import { render, staticRenderFns } from "./PreventiveMaintenanceMainTable.vue?vue&type=template&id=21f820d3&scoped=true&"
import script from "./PreventiveMaintenanceMainTable.vue?vue&type=script&lang=ts&"
export * from "./PreventiveMaintenanceMainTable.vue?vue&type=script&lang=ts&"
import style0 from "./PreventiveMaintenanceMainTable.vue?vue&type=style&index=0&id=21f820d3&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f820d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VChipGroup,VCol,VDataTable,VRow,VSpacer,VToolbar,VToolbarItems,VToolbarTitle,VTooltip})
